import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import { reducer as referencesReducer } from 'layouts/admin-layout/redux';
import { reducer as articleReducer } from 'pages/admin/articles-form/redux';
import { reducer as articlesReducer } from 'pages/admin/articles/redux';
import { reducer as categoriesReducer } from 'pages/admin/categories/redux';
import { reducer as countriesReducer } from 'pages/admin/countries/redux';
import { reducer as hashtagsReducer } from 'pages/admin/hashtags/redux';
import { reducer as adminMenuReducer } from 'pages/admin/menu/redux';
import { topMenuApiReducer as topMenuReducer } from 'layouts/front-layout/redux';
import { sideMenuApiReducer as sideMenuReducer } from 'layouts/front-layout/redux';
import { reducer as settingsReducer } from 'pages/admin/settings';
import { reducer as userFormReducer } from 'pages/admin/user-form/redux';
import { reducer as userListReducer } from 'pages/admin/users/redux';
import { reducer as contentReducer } from 'pages/content/redux';
import { reducer as searchReducer } from 'pages/search-results/redux';
import { reducer as userReducer } from '../auth/redux';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

const middleWares = applyMiddleware(thunkMiddleware);

const staticReducers = {
  adminMenu: adminMenuReducer,
  article: articleReducer,
  articles: articlesReducer,
  categories: categoriesReducer,
  content: contentReducer,
  countries: countriesReducer,
  hashtags: hashtagsReducer,
  references: referencesReducer,
  searchResults: searchReducer,
  settings: settingsReducer,
  sideMenu: sideMenuReducer,
  topMenu: topMenuReducer,
  user: userReducer,
  userForm: userFormReducer,
  userList: userListReducer,
};

const createReducer = () =>
  combineReducers({
    ...staticReducers,
  });

const enhancers =
  process.env.NODE_ENV === 'production'
    ? middleWares
    : composeWithDevTools(middleWares);

export default () => {
  const store = createStore(createReducer(), {}, enhancers);

  // store.asyncReducers = {};
  //
  // store.injectReducer = (key, asyncReducer) => {
  //   if (store.asyncReducers[key]) {
  //     return;
  //   }
  //
  //   store.asyncReducers[key] = asyncReducer;
  //   store.replaceReducer(createReducer(store.asyncReducers));
  // };

  return store;
};

const store = createStore(createReducer(), {}, enhancers);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
